import { createContext, useContext, useState, ReactNode } from 'react';
import { lockScroll } from '../core/helpers';

const BookMeetingModalContext = createContext<{
  isModalOpened: boolean;
  closeModal: () => void;
  openModal: () => void;
}>({ isModalOpened: false, closeModal: () => {}, openModal: () => {} });

export function HubspotBookMeetingModalWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const [isModalOpened, setIsModalOpened] = useState(false);

  const closeModal = () => {
    setIsModalOpened(false);
    lockScroll(false);
  };

  const openModal = () => {
    setIsModalOpened(true);
    lockScroll(true);
  };

  return (
    <BookMeetingModalContext.Provider
      value={{
        isModalOpened,
        closeModal,
        openModal,
      }}
    >
      {children}
    </BookMeetingModalContext.Provider>
  );
}

export function useBookMeetingModal() {
  return useContext(BookMeetingModalContext);
}
